import styled from 'styled-components';

export const DashboardPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 20px;
`;

export const DashboardFiltersBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
`;

export const DashboardFiltersRight = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
`;

export const RangeTabs = styled.div`
  display: inline-flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid #d8dde3;
  border-radius: 16px;
  padding: 6px;
  gap: 4px;
  box-shadow: 0 2px 8px rgba(15, 35, 52, 0.08);
`;

export const RangeTab = styled.button<{ active?: boolean; isCustom?: boolean }>`
  border: none;
  border-radius: 10px;
  padding: 8px 13px;
  font-size: 17px;
  line-height: 1;
  font-family: 'Proxima Nova Semibold';
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: ${({ active }) => (active ? '#1f8bff' : 'transparent')};
  color: ${({ active, isCustom }) => (active ? '#ffffff' : isCustom ? '#1f8bff' : '#2f3a45')};
  box-shadow: ${({ active }) => (active ? '0 4px 10px rgba(31, 139, 255, 0.35)' : 'none')};
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
  position: relative;

  ${({ isCustom }) =>
    isCustom
      ? `
    margin-left: 8px;
    &::before {
      content: '';
      position: absolute;
      left: -8px;
      top: 8px;
      bottom: 8px;
      width: 1px;
      background: #d8dde3;
    }
  `
      : ''}

  &:hover {
    background: ${({ active }) => (active ? '#1f8bff' : '#f4f8ff')};
    color: ${({ active, isCustom }) => (active ? '#ffffff' : isCustom ? '#1f8bff' : '#1a2c3f')};
  }

  @media (max-width: 1024px) {
    font-size: 15px;
    padding: 8px 11px;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 7px 9px;
  }
`;

export const RangeTabCustomIcon = styled.span<{ active?: boolean }>`
  display: inline-flex;
  align-items: center;

  svg {
    width: 20px;
    height: 20px;
    color: ${({ active }) => (active ? '#ffffff' : '#1f8bff')};
    stroke: ${({ active }) => (active ? '#ffffff' : '#1f8bff')};
  }

  @media (max-width: 768px) {
    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

export const DashboardSectionTitle = styled.h2`
  margin: 0;
  margin-right: 12px;
  font-size: 26px;
  font-weight: 600;
  color: var(--DarkGray);

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

